import { render, staticRenderFns } from "./SeniorDetail.vue?vue&type=template&id=a822a8e0&scoped=true"
import script from "./SeniorDetail.vue?vue&type=script&lang=js"
export * from "./SeniorDetail.vue?vue&type=script&lang=js"
import style0 from "./SeniorDetail.vue?vue&type=style&index=0&id=a822a8e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a822a8e0",
  null
  
)

export default component.exports